export default "__VITE_ASSET__gqwJbsMx__"